export default __webpack_public_path__ + "static/media/Cosmeceutical.688b247d.jpeg";